module.exports = __webpack_public_path__ + "static/hero-dcc17b75d03bcaa628023ec01c6c2a03.png";